async function getPortalAccessURL() {
  try {
    const session = await recharge.auth.loginShopifyAppProxy();

    if (session.customerId === null) {
      const messageContainer = document.getElementById(
        "subscription-message-container"
      );

      const loadingContainer = document.querySelector(
        ".manage-subscription__loading-container"
      );
      if (loadingContainer) {
        loadingContainer.style.display = "none";
      }

      messageContainer.classList.add("active");

      messageContainer.innerHTML = `
          <h3>You don’t have any active subscriptions.</h3>
          <span>Once you've added some subscription products, you'll be able to view and edit them here.</span>
        `;
    } else {
      window.location.href = "/tools/recurring/login/";
    }
  } catch (error) {
    console.error("Error checking customerId:", error);
  }
}

getPortalAccessURL();
